import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/gree-logo.svg';
import header_logo from '../../assets/images/Logo.svg';
import footer_logo from '../../assets/images/footer-logo.svg';

const Header5 = () => {
  const [isMenuExpanded, setMenuExpanded] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const toggleMenu = () => {
    setMenuExpanded(prevState => !prevState);
    document.body.classList.toggle('locked', !isMenuExpanded);
  };
  const toggleSideMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle("mobile-menu-open", !isMenuOpen);
  };
  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };
  return (
    <>
      <header className="main-header header-five" id="no-sticky-header">
        <div className="container-fluid">
          <nav className="main-menu">
            <div className="main-menu-logo">
              <Link to="/">
                <img src={Logo} alt="header-logo" />
              </Link>
            </div>
            <div className="main-menu-inner">
              <ul className="main-menu-list">
                <li className="menu-item-children active">
                  <Link to="#">Home</Link>
                  <i className="fa-solid fa-chevron-down" />
                  <ul>
                    <li>
                      <Link to="/">Home One</Link>
                    </li>
                    <li>
                      <Link to="/HomeTwo">Home Two</Link>
                    </li>
                    <li>
                      <Link to="/HomeThree">Home Three</Link>
                    </li>
                    <li>
                      <Link to="/HomeFour">Home Four</Link>
                    </li>
                    <li>
                      <Link to="/HomeFive">Home Five</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-children">
                  <Link to="#">Pages</Link>
                  <i className="fa-solid fa-chevron-down" />
                  <ul>
                    <li>
                      <Link to="/Aboutus">About Us</Link>
                    </li>
                    <li>
                      <Link to="/Careers">Careers</Link>
                    </li>
                    <li>
                      <Link to="/Team">Meet The Team</Link>
                    </li>
                    <li>
                      <Link to="/Testimonial">Testimonial</Link>
                    </li>
                    <li>
                      <Link to="Pricing">Pricing</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-children">
                  <Link to="#">Services</Link>
                  <i className="fa-solid fa-chevron-down" />
                  <ul>
                    <li>
                      <Link to="/Services">Services </Link>
                    </li>
                    <li>
                      <Link to="/ServiceDetails">Services Details</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-children">
                  <Link to="#">Portfolio</Link>
                  <i className="fa-solid fa-chevron-down" />
                  <ul>
                    <li>
                      <Link to="/Portfolio">Portfolio</Link>
                    </li>
                    <li>
                      <Link to="/Details">Portfolio Details</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-children">
                  <Link to="#">Blog</Link>
                  <i className="fa-solid fa-chevron-down" />
                  <ul>
                    <li>
                      <Link to="/Blog">Blog Standard</Link>
                    </li>
                    <li>
                      <Link to="/BlogDetails">Blog Details</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-children">
                  <Link to="#">Shop</Link>
                  <i className="fa-solid fa-chevron-down" />
                  <ul>
                    <li>
                      <Link to="/Shop">Shop</Link>
                    </li>
                    <li>
                      <Link to="/ProdectDetails">Product Details</Link>
                    </li>
                    <li>
                      <Link to="/Cart">Cart</Link>
                    </li>
                    <li>
                      <Link to="/CheckOut">Checkout</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-children">
                  <Link to="/Contact">Contact Us</Link>
                </li>
              </ul>
              <div className="header-menu-collaps" onClick={toggleSideMenu}>
                <span className="line-1" />
                <span className="line-2" />
                <span className="line-3" />
              </div>
              <div className={`mobile-nav-wrapper ${isMenuOpen ? "expanded" : ""}`}>

                <div className="mobile-nav-overlay" onClick={toggleSideMenu}></div>
                <div className="mobile-nav-content">
                  <button className="mobile-nav-close" onClick={toggleSideMenu} style={{ background: "none", fontSize: 50, border: "none", position: "fixed", top: 10, color: "#fff" }}>
                    ×
                  </button>
                  <div className="logo-box">
                    <Link to="/">
                      <img width="150" src={header_logo} alt="logo" />
                    </Link>
                  </div>
                  <div className="mobile-nav-container">
                    <ul className="mobile-menu-list">

                      <li className={`menu-item-has-children ${openDropdown === 1 ? "dropdown-open" : ""}`}>
                        <Link to="#" onClick={() => toggleDropdown(1)}>Home <i className="fa-solid fa-chevron-down" /></Link>
                        {openDropdown === 1 && (
                          <ul>
                            <li><Link to="/">Home-1</Link></li>
                            <li><Link to="/HomeTwo">Home-2</Link></li>
                            <li><Link to="/HomeThree">Home-3</Link></li>
                            <li><Link to="/HomeFour">Home-4</Link></li>
                            <li><Link to="/HomeFive">Home-5</Link></li>
                          </ul>
                        )}
                      </li>
                      <li className={`menu-item-has-children ${openDropdown === 2 ? "dropdown-open" : ""}`}>
                        <Link to="#" onClick={() => toggleDropdown(2)}>Pages <i className="fa-solid fa-chevron-down" /></Link>
                        {openDropdown === 2 && (
                          <ul>
                            <li><Link to="/Aboutus">About Us</Link></li>
                            <li><Link to="/Careers">Careers</Link></li>
                            <li><Link to="/Team">Meet The Team</Link></li>
                            <li><Link to="/Testimonial">Testimonial</Link></li>
                            <li><Link to="/Pricing">Pricing</Link></li>
                          </ul>
                        )}
                      </li>
                      <li className={`menu-item-has-children ${openDropdown === 3 ? "dropdown-open" : ""}`}>
                        <Link to="#" onClick={() => toggleDropdown(3)}>Services <i className="fa-solid fa-chevron-down" /></Link>
                        {openDropdown === 3 && (
                          <ul>
                            <li><Link to="/Services">Services</Link></li>
                            <li><Link to="/ServiceDetails">Service Details</Link></li>
                          </ul>
                        )}
                      </li>
                      <li className={`menu-item-has-children ${openDropdown === 4 ? "dropdown-open" : ""}`}>
                        <Link to="#" onClick={() => toggleDropdown(4)}>Portfolio <i className="fa-solid fa-chevron-down" /></Link>
                        {openDropdown === 4 && (
                          <ul>
                            <li><Link to="/Portfolio">Portfolio</Link></li>
                            <li><Link to="/Details">Portfolio Details</Link></li>
                          </ul>
                        )}
                      </li>
                      <li className={`menu-item-has-children ${openDropdown === 5 ? "dropdown-open" : ""}`}>
                        <Link to="#" onClick={() => toggleDropdown(5)}>Blog <i className="fa-solid fa-chevron-down" /></Link>
                        {openDropdown === 5 && (
                          <ul>
                            <li><Link to="/Blog">Blog Standard</Link></li>
                            <li><Link to="/BlogDetails">Blog Details</Link></li>
                          </ul>
                        )}
                      </li>
                      <li className={`menu-item-has-children ${openDropdown === 6 ? "dropdown-open" : ""}`}>
                        <Link to="#" onClick={() => toggleDropdown(6)}>Shop <i className="fa-solid fa-chevron-down" /></Link>
                        {openDropdown === 6 && (
                          <ul>
                            <li><Link to="/Shop">Shop</Link></li>
                            <li><Link to="/ProductDetails">Product Details</Link></li>
                            <li><Link to="/Cart">Cart</Link></li>
                            <li><Link to="/Checkout">Checkout</Link></li>
                          </ul>
                        )}
                      </li>
                      <li>
                        <Link to="/Contact">Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="main-menu-right">
                <div className="header-side-menu" onClick={toggleMenu}>
                  <span className="line-1" />
                  <span className="line-2" />
                </div>

                <div className={`side-menu-wrapper ${isMenuExpanded ? 'expanded' : ''}`}>
                  <div
                    className={`side-menu-overlay ${isMenuExpanded ? 'expanded' : ''}`}
                    onClick={toggleMenu}
                  ></div>

                  <div className={`side-menu-content ${isMenuExpanded ? 'expanded' : ''}`}>
                    <Link to="" className="side-menu-toggler" onClick={toggleMenu}>
                      <span></span>
                      <span></span>
                    </Link>
                    <div className="side-menu-logo-box">
                      <Link to="/">
                        <img src={footer_logo} alt="logo" />
                      </Link>
                    </div>
                    <div className="side-menu-container">
                      <p>
                        Uniqo - Business Consulting WordPress Theme for professionals, services, and solutions.
                      </p>
                      <h4>Contact Info</h4>
                      <ul>
                        <li><span>Mon - Fri: 8:00 - 16:00</span></li>
                        <li><Link to="mailto:help@company.com">help@company.com</Link></li>
                        <li><Link to="tel:+12009845611">+120.098.456 11</Link></li>
                      </ul>
                      <h4>Office Address</h4>
                      <p>28 Valencia Street, New York, United States of America</p>
                      <ul className="side-menu-social-media">
                        <li><Link to="https://www.facebook.com/"><i className="fa-brands fa-facebook-f"></i></Link></li>
                        <li><Link to="https://x.com/"><i className="fa-brands fa-twitter"></i></Link></li>
                        <li><Link to="https://www.instagram.com/"><i className="fa-brands fa-instagram"></i></Link></li>
                        <li><Link to="https://in.linkedin.com/"><i className="fa-brands fa-linkedin-in"></i></Link></li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </nav>
        </div>
      </header>

    </>
  )
}

export default Header5;
